(() => {
  if (customElements.get('editorial-buy-bar')) return;
  customElements.define('editorial-buy-bar', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.sync = () => {
        this.frame = null;
        const footer = document.querySelector('footer .foot');
        const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight;
        // A section that already shows the price and buy button (data-buy-bar-hide) hides the bar while on screen.
        const offerVisible = [...document.querySelectorAll('[data-buy-bar-hide]')].some((el) => {
          const r = el.getBoundingClientRect();
          return r.top < innerHeight && r.bottom > 0;
        });
        const focused = this.contains(document.activeElement);
        const visible = focused || (scrollY > innerHeight * .5 && !footerVisible && !offerVisible);
        this.toggleAttribute('data-visible', visible);
        this.inert = !visible;
      };
      const queue = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.sync);
      };
      window.addEventListener('scroll', queue, { passive: true, signal });
      window.addEventListener('resize', queue, { signal });
      this.addEventListener('focusout', queue, { signal });
      document.addEventListener('shopify:section:load', queue, { signal });
      document.addEventListener('shopify:section:unload', queue, { signal });
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
})();
